<script setup>
import { avatar } from "@/services/usuarios";
import { useAuthStore } from "@/stores/auth";
import { computed, onMounted } from "vue";

const store = useAuthStore();
const usuario = computed(() => store.usuario);

const props = defineProps({
    context: Object, // El contexto del nodo de FormKit
})

const uploadImage = (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    avatar(formData).then((res) => {
        store.usuario.urlImagen = res.url + "?t=" + new Date().getTime();

        // Actualizar el componente padre
        props.context.node.input(store.usuario.urlImagen);

    });
}

// On mounted set the value of the input
onMounted(() => {
    if (usuario.value.urlImagen) {
        props.context.node.input(usuario.value.urlImagen);
    }
});

</script>

<template>
    <div class="">
        <!-- Si la tiene, mostrar una imagen chiquita y un texto que diga "Cambiar imagen" -->
        <div v-if="usuario.urlImagen" class="avatar-preview">
            <img :src="usuario.urlImagen + '?t=' + new Date().getTime()" alt="Imagen de perfil" class="avatar-player" />
            <button @click="usuario.urlImagen = null" class="delete-button">Cambiar imagen</button>
        </div>

        <input v-else type="file" @change="uploadImage" class="file-input" />
    </div>
</template>

<style scoped>
.avatar-upload {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
}

.avatar-preview {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 1rem;
}

.avatar-player {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #ccc;
    cursor: pointer;
}

.delete-button {
    padding: 0.4rem;
    border: none;
    background-color: black;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    font-size: 0.8rem !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.delete-button:hover {
    background-color: #333;
}

.upload-input {
    display: flex;
    width: 100%;
}

.file-input {
    width: 100%;
    padding: 0.5rem;
    border: 2px solid #ccc;
    border-radius: 8px;
    font-size: 1rem;
}
</style>
